import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { api } from "@/lib/api";

export default function Legal() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);
    api.get(`/legal/${slug}`)
      .then((r) => setDoc(r.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      <SiteHeader />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid={`legal-${slug}`}>
        {loading ? (
          <div className="text-center py-24 text-gray-500">Chargement…</div>
        ) : error || !doc ? (
          <div className="text-center py-24 text-gray-500">Page introuvable.</div>
        ) : (
          <article className="bg-white rounded-3xl p-8 md:p-12 mbk-card-shadow border border-gray-100">
            <h1 className="font-display text-3xl md:text-4xl font-black text-[#0a1e3f]">{doc.title}</h1>
            {doc.updated_at && (
              <p className="text-xs text-gray-500 mt-2">Dernière mise à jour : {new Date(doc.updated_at).toLocaleDateString("fr-FR")}</p>
            )}
            <div className="mt-6 prose prose-sm max-w-none whitespace-pre-line text-gray-700 leading-relaxed" data-testid="legal-content">
              {doc.content}
            </div>
          </article>
        )}
      </div>
      <SiteFooter />
    </div>
  );
}
